import BaseModelAPI from '../BaseModelAPI';

export default class AreaList extends BaseModelAPI {

	static entity = 'arealist'
	static entityName = 'area';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
